import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Menu, MenuItem, ListItemText } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { KeyboardArrowDown } from "@material-ui/icons";

const useStyles = makeStyles({
  button: {
    padding: "5px 0",
    "&:hover": {
      backgroundColor: "#FFF"
    },
    margin: 0,
    fontSize: 13
  },
  itemText: {
    fontSize: 13,
    fontWeight: "bold",
    "&:hover": {
      color: "#FF8200"
    }
  },
  itemIcon: {
    fontSize: 40,
    fontWeight: "bold",
    margin: 15,
    "&:hover": {
      color: "#FF8200"
    }
  },
  itemMenu: {
    width: 290,
    height: 60,
    display: "flex",
    flexDirection: "row",
    textAlign: "left",
    justifyContent: "space-between",
    fontSize: 12,
    "&:hover": {
      color: "#FF8200",
      fill: "#FF8200"
    }
  }
});

const HeaderOption = ({ title, elements, fixed, id }) => {
  const styles = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleItemClick = (event, url) => {
    event.preventDefault();
    // onChange(event.target.innerText);
    event.target.innerText === "PERSONAS"
      ? window.location.reload()
      : window.open(url);

    handleClose();
  };

  const HeaderMenu = children => (
    <Menu
      elevation={0}
      variant={`menu`}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center"
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center"
      }}
      {...children}
    />
  );

  return (
    <div>
      <Button
        aria-controls={`${id}`}
        aria-haspopup="true"
        onClick={handleClick}
        size="large"
        className={styles.button}
      >
        {title}
        <KeyboardArrowDown />
      </Button>
      {fixed && (
        <HeaderMenu
          key={`hm-${id}`}
          id={`${id}`}
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          disableScrollLock={true}
        >
          {elements.map(element => {
            const ElementIcon = element.icon;
            return (
              <MenuItem
                key={`menu-${element.key}`}
                id={`menu-${element.key}`}
                onClick={event => handleItemClick(event, element.url)}
                className={styles.itemMenu}
              >
                <ElementIcon className={styles.itemIcon} />
                <ListItemText
                  primary={`${element.value}`}
                  classes={{ primary: styles.itemText }}
                />
              </MenuItem>
            );
          })}
        </HeaderMenu>
      )}
    </div>
  );
};

HeaderOption.propTypes = {
  title: PropTypes.string.isRequired,
  elements: PropTypes.array.isRequired,
  fixed: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired
};

export default HeaderOption;
